import { DocumentVersion } from "../types/salonDocument";

export function formatSalonDocumentVersionTimestamp(
  iso: string | undefined,
): string {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch {
    return iso;
  }
}

/** Initials for avatar chips (e.g. "Jane Doe" → "JD"). */
export function initialsFromStaffDisplayName(name: string): string {
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (
    `${parts[0][0] ?? ""}${parts[parts.length - 1][0] ?? ""}`.toUpperCase() ||
    "?"
  );
}

function staffNameFromMetadata(
  meta: Record<string, unknown> | null | undefined,
): string | null {
  if (!meta) return null;
  for (const key of [
    "uploadedByName",
    "savedByName",
    "createdByName",
    "authorName",
    "userName",
  ]) {
    const v = meta[key];
    if (typeof v === "string" && v.trim()) return v.trim();
  }
  return null;
}

/**
 * Prefer API `createdByStaffName`, then version metadata (charts / legacy uploads).
 */
export function salonDocumentVersionStaffDisplayName(
  v: DocumentVersion,
): string | null {
  const fromApi = v.createdByStaffName?.trim();
  if (fromApi) return fromApi;
  return staffNameFromMetadata(
    v.metadata as Record<string, unknown> | null | undefined,
  );
}

/** Short description: display name, else optional note in metadata. */
export function salonDocumentVersionDescriptionLine(
  v: DocumentVersion,
): string | null {
  const dn = v.displayName?.trim();
  if (dn) return dn;
  const meta = v.metadata;
  if (
    meta &&
    typeof meta === "object" &&
    typeof (meta as { note?: unknown }).note === "string"
  ) {
    const note = (meta as { note: string }).note.trim();
    if (note) return note;
  }
  return null;
}
